module.exports = __webpack_public_path__ + "110b0f70ec9b7d33bae3fea69a30ac31.png";